import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
class CustomerChildrenResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.customerId = 0;
    }
    pk() {
        return this.customerId?.toString() || "";
    }
}
CustomerChildrenResource.urlRoot = apiResourceUrl("customer-children");
export { CustomerChildrenResource };
//# sourceMappingURL=CustomerChildrenResource.js.map